export enum CashierPreferenceLevel {
  Zero = 0,
  One,
  Two,
  Three,
}

export enum SizeType {
  Medium = 0,
  Large,
}
